import Darkswitch from "./darkswitch";
import Github from "./github";
import Instagram from "./instagram";
import LightSwitch from "./lightswitch";
import Linkedin from "./linkedin";
import Logo from "./logo";
import SendIcon from "./send_icon";
import Twitter from "./twitter";
import Javascript from './javascript';
import Css from "./css";
import Html5 from './html5';
import Git from "./git";
import ReactIcon from './react';
import Nodejs from './nodejs';
import Redux from './redux';
import BouncyArrow from './bouncyArrow';
import WebIcon from "./website";
import OpenIcon from "./open";
import Close from "./close";

// add imports to array

export const DarkswitchIcon = Darkswitch;
export const GithubIcon = Github
export const InstagramIcon = Instagram
export const LightSwitchIcon = LightSwitch
export const LinkedinIcon = Linkedin
export const LogoIcon = Logo
export const SendIconIcon = SendIcon
export const TwitterIcon = Twitter
export const JavascriptIcon = Javascript
export const Html5Icon = Html5
export const GitIcon = Git
export const CssIcon = Css
export const ReactIconIcon = ReactIcon
export const ReduxIcon = Redux
export const NodejsIcon = Nodejs;
export const BouncyArrowIcon = BouncyArrow;
export const WebIconIcon = WebIcon;
export const OpenIconIcon = OpenIcon;
export const CloseIcon = Close;




const Icons = {
Github,
Instagram,
LightSwitch,
Linkedin,
Logo,
SendIcon,
Twitter,
Javascript,
Git,
Html5,
Css,
Nodejs,
ReactIcon,
Redux,
BouncyArrow,
OpenIcon,
Close,
WebIcon,
}

export default Icons;
// 